import {target} from '../utils/dom';
import scrollTo from '../utils/scroll-to';
import getOffset from '../utils/get-offset';

const triggerAttribute = 'data-anchor';
const anchorEvent = new CustomEvent('anchor', {bubbles: true});
const scrollOfsset = -40;

document.addEventListener('click', click);

if (window.location.hash) {
	const el = document.query(window.location.hash);
	if (el) {
		setTimeout(() => scroll(el), 500);
	}
}

function click(event) {
	let tar = target(event.target, `[${triggerAttribute}]`);
	if (tar) {
		clickAnchor(tar);
	}
}

function clickAnchor(el) {
	let section;
	const href = el.getAttribute('href') || el.getAttribute('data-anchor');

	if (href) {
		section = document.query(href);
		scroll(section);
	}
}

function scroll(el) {
	const top = getOffset(el).top + scrollOfsset;
	scrollTo(top);
	el.dispatchEvent(anchorEvent);
}
